module.exports = __webpack_public_path__ + "img/light-mud-decal-22.ce917a78.png";